import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/goal-capture/edit-pencil.svg'
import _imports_1 from '../../assets/goal-capture/open-quote.svg'
import _imports_2 from '../../assets/goal-capture/close-quote.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3e64465b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "edit-button",
  "data-test": "goal-edit-button",
  "data-role": "trigger"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Edit"
  })
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  role: "separator",
  class: "divider"
}
const _hoisted_4 = { class: "goal-input-container" }
const _hoisted_5 = {
  key: 0,
  class: "mt-40"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "goal-doc-paragraph mt-40" }, "Once you’re happy with this goal, capture it below.", -1))
const _hoisted_7 = { class: "center-flex" }
const _hoisted_8 = {
  key: 1,
  class: "mt-40 locked-analyses-container"
}
const _hoisted_9 = {
  key: 1,
  class: "analysis-not-available-container"
}
const _hoisted_10 = { class: "capture-goal-modal" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "🎯 Capture Goal?", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Open Quote"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Close Quote"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal-subtext" }, "Note: You will be able to edit your goals after capturing them", -1))

import { computed, ref, inject, Ref } from "vue";
import { Modal, Dropdown } from "uiv";
import axios, { AxiosError } from "axios";
import GoalCaptureBox from "./goal-capture-box.vue";
import { TeamGoal } from "../../views/cms/cms-goal-capture-page.vue";
import GoalAnalysis from "./goal-analysis.vue";
import GoalSuggestionBox from "./goal-suggestion-box.vue";
import { CmsGoalAnalysis } from "../../services/cms/cms-type-definitions";
import { csContext } from "../../services/cs-context";
import { TeamGoalAnalysisApiModel } from "../../api-models";
import goalCaptureStore from "../../stores/goal-capture-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'goal-area',
  props: {
    goalIndex: {},
    goal: {},
    cmsAnalyses: {},
    suggestionPrompt: {}
  },
  emits: ["update:lockStatus", "deleteGoal", "update:goal"],
  setup(__props: any, { emit: __emit }) {

const isTeamLead = inject("isTeamAdmin") as Ref<boolean>;

const props = __props;

const goalName = ref(props.goal.goalName);
const showModal = ref(false);
const error = ref("");
const analyses = ref<TeamGoalAnalysisApiModel[]>(props.goal.teamGoalAnalyses);

const locked = computed(() => props.goal.locked);

const hasEnteredInput = computed(() => goalName.value.length > 0);

const emit = __emit;

function updateGoalName(newValue: string) {
  goalName.value = newValue;
}

function closeModal() {
  showModal.value = false;
}

function handleGoalSubmit() {
  showModal.value = true;
}

function handleEditClick() {
  emit("update:lockStatus", props.goalIndex, false);
}

function getAnalysis(type: string): TeamGoalAnalysisApiModel | undefined {
  return analyses.value.find((a) => a.analysisType === type);
}

function handleDeleteClick() {
  emit("deleteGoal", props.goalIndex);
  goalCaptureStore.deleteSuggestionsForGoal(props.goalIndex);
}

async function saveNewGoal() {
  const { data: id } = await axios.post<string>("/api/teamgoals", {
    teamId: csContext.currentTeam?.id,
    goalName: goalName.value,
  });

  return id;
}

async function saveEditedGoal() {
  await axios.put("/api/teamgoals", {
    id: props.goal.id,
    teamId: csContext.currentTeam?.id,
    goalName: goalName.value,
  });
}

async function updateAnalysis(analysis: string, analysisType: string) {
  const index = analyses.value.findIndex((a) => a.analysisType === analysisType);

  if (index === -1) {
    analyses.value.push({ analysis, analysisType });
  } else {
    analyses.value[index].analysis = analysis;
  }
}

async function captureGoal() {
  try {
    let id = "";
    if (props.goal.id) {
      await saveEditedGoal();
      analyses.value.forEach((a) => updateAnalysis("", a.analysisType));
    } else {
      id = await saveNewGoal();
    }

    emit("update:goal", props.goalIndex, {
      id: id || props.goal.id,
      goalName: goalName.value,
      locked: true,
      createdById: csContext.user.id,
    });
    closeModal();
  } catch (e: any) {
    error.value = (e as AxiosError).message;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["goal-heading", { 'mt-40': _ctx.goalIndex !== 0 }])
    }, [
      (_unref(isTeamLead))
        ? (_openBlock(), _createBlock(_unref(Dropdown), {
            key: 0,
            class: "edit-dropdown",
            "menu-right": ""
          }, {
            dropdown: _withCtx(() => [
              (locked.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                    _createElementVNode("a", {
                      role: "button",
                      tabindex: "0",
                      onClick: handleEditClick,
                      onKeyup: _withKeys(handleEditClick, ["enter"]),
                      "data-test": "edit-goal-option"
                    }, "Edit", 32)
                  ]))
                : _createCommentVNode("", true),
              (locked.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  role: "button",
                  tabindex: "0",
                  onClick: handleDeleteClick,
                  onKeyup: _withKeys(handleDeleteClick, ["enter"]),
                  "data-test": "delete-goal-option"
                }, "Delete", 32)
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("h3", null, "🎯 Goal " + _toDisplayString(_ctx.goalIndex + 1), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(GoalCaptureBox, {
          "onUpdate:goalName": updateGoalName,
          text: goalName.value,
          label: `team goal ${_ctx.goalIndex}`,
          "goal-number": _ctx.goalIndex,
          locked: locked.value || !_unref(isTeamLead)
        }, null, 8, ["text", "label", "goal-number", "locked"])
      ])
    ], 2),
    (hasEnteredInput.value && !locked.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(GoalSuggestionBox, {
            "goal-input": goalName.value,
            "goal-index": _ctx.goalIndex,
            prompt: _ctx.suggestionPrompt,
            "onUpdate:goalName": updateGoalName
          }, null, 8, ["goal-input", "goal-index", "prompt"]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _withModifiers(handleGoalSubmit, ["prevent"]),
              "data-test": "submit-goal-button"
            }, " Capture Goal ")
          ])
        ]))
      : (hasEnteredInput.value && locked.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cmsAnalyses, (analysis) => {
              return (_openBlock(), _createElementBlock("div", {
                key: analysis.type
              }, [
                (
            (_unref(isTeamLead) && _ctx.goal.createdById === _unref(csContext).user.id) ||
            !!getAnalysis(analysis.type)?.analysis
          )
                  ? (_openBlock(), _createBlock(GoalAnalysis, {
                      key: 0,
                      "goal-id": _ctx.goal.id,
                      "goal-input": goalName.value,
                      prompt: analysis.smart_callout.data.prompt,
                      analysis: getAnalysis(analysis.type),
                      "cms-analysis-type": analysis.type,
                      "onUpdate:analysis": updateAnalysis
                    }, null, 8, ["goal-id", "goal-input", "prompt", "analysis", "cms-analysis-type"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, " This analysis is still being generated for your Team Lead. Once finished, you’ll be able to see it here. Refresh the page to check. "))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
    (showModal.value)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 2,
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
          header: false,
          footer: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("p", null, _toDisplayString(goalName.value), 1),
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("div", { style: {"margin-bottom":"10px"} }, [
                _createElementVNode("button", {
                  class: "btn btn-default",
                  onClick: closeModal,
                  type: "button"
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: captureGoal,
                  type: "button",
                  style: {"margin-left":"20px"},
                  "data-test": "capture-goal-modal-button"
                }, " Capture Goal ")
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})